
import { ReactNode } from 'react';
import { AppSidebar } from '../AppSidebar';
import { SidebarProvider } from '@/components/ui/sidebar';
import { Header } from '../layout/Header';
import { useIsMobile } from '@/hooks/use-mobile';

// Layout for authenticated routes with sidebar
export const AuthenticatedLayout = ({ children }: { children: ReactNode }) => {
  const isMobileOrTabletPortrait = useIsMobile(true);
  
  return (
    <SidebarProvider>
      <Header />
      <div className="flex min-h-screen overflow-x-hidden">
        <AppSidebar />
        <main className={`${isMobileOrTabletPortrait ? '' : 'md:ml-32'} flex-1 overflow-y-auto overflow-x-hidden mt-[72px] w-full max-w-full`}>
          <div className="w-full max-w-full mx-auto py-6 px-0 sm:px-0 rounded-none shadow-none my-0">
            {children}
          </div>
        </main>
      </div>
    </SidebarProvider>
  );
};

// Public routes without sidebar
export const PublicLayout = ({ children }: { children: ReactNode }) => {
  return (
    <>
      <Header />
      <main className="min-h-screen mt-[72px] overflow-x-hidden w-full max-w-full">
        {children}
      </main>
    </>
  );
};
